export default __webpack_public_path__ + "static/media/white_mode_new_back.171a3c0c.svg";